import type { ApiClient } from "@positive/api-client";

/** A notification centre entry (`GET /api/msg/notifications`, D14-9): texts are i18n keys with arguments. */
export interface NotificationEntry {
  id: string;
  type: string;
  severity: "information" | "success" | "warning" | "error";
  titleKey: string;
  bodyKey: string | null;
  args: Record<string, string>;
  link: string | null;
  createdAt: string;
  readAt: string | null;
}

export interface NotificationPage {
  items: NotificationEntry[];
  totalCount: number;
  unreadCount: number;
}

export const notificationKeys = { list: ["msg", "notifications"] as const };

/** Path of the SignalR hub (ADR-0010/D-8), below `/api`. */
export const notificationHubPath = "/api/msg/hub";

export const notificationsApi = {
  list: (client: ApiClient, signal?: AbortSignal) =>
    client.get<NotificationPage>("msg/notifications", { query: { pageSize: 30 }, ...(signal ? { signal } : {}) }),
  markRead: async (client: ApiClient, id: string) =>
    (await client.post<{ unreadCount: number }>(`msg/notifications/${encodeURIComponent(id)}/read`)).data,
  markAllRead: async (client: ApiClient) =>
    (await client.post<{ unreadCount: number }>("msg/notifications/read-all")).data,
};
